import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultationService {

  constructor(
    private http: HttpClient
  ) { }

  apiUrl: string = `${environment.HOST}`;

  consultationByCustomer(channel, identification, date, page?, crm?, type?, size?){
    return this.http.get(`${this.apiUrl}/api/${channel}/transactions-tracking/search?identification=${identification}&date=${date}&crm=${crm || ""}&type=${type || ""}&page=${page - 1}&size=${size || ""}`);
  }

  consultationByTransactionId(channel, idTransaction, date, page?, crm?, type?, size?){
    return this.http.get(`${this.apiUrl}/api/${channel}/transactions-tracking/search?idTransaction=${idTransaction}&date=${date}&crm=${crm || ""}&type=${type || ""}&page=${page - 1}&size=${size || ""}`);
  }

  consultationByTransactionIdTracking(channel, idTransaction){
    return this.http.get(`${this.apiUrl}/api/${channel}/transactions-tracking/${idTransaction}`);
  }

  consultationByCustomer_CP(identification, date, page?, crm?, type?, size?){
    return this.http.get(`${this.apiUrl}/api/cp/transactions-tracking/search?identification=${identification}&date=${date}&crm=${crm || ""}&type=${type || ""}&page=${page - 1}&size=${size || ""}`);
  }

  consultationByTransactionId_CP(idTransaction, date?, page?, crm?, type?, size?){
    return this.http.get(`${this.apiUrl}/api/cp/transactions-tracking/search?idTransaction=${idTransaction}&date=${date}&crm=${crm || ""}&type=${type || ""}&page=${page - 1 || 0}&size=${size || ""}`);
  }

  monthlyConsultation(channel, year, month){
    return this.http.get(`${this.apiUrl}/api/${channel}/transactions-tracking/month/${year}-${month}`);
  }

  monthlyConsultation_CP(year, month){
    return this.http.get(`${this.apiUrl}/api/cp/transactions-tracking/month/${year}-${month}`);
  }

  weeklyConsultation(channel, start, end){
    return this.http.get(`${this.apiUrl}/api/${channel}/transactions-tracking/between/${start}/to/${end}`);
  }

  weeklyConsultation_CP(start, end){
    return this.http.get(`${this.apiUrl}/api/cp/transactions-tracking/between/${start}/to/${end}`);
  }

  downloadContract(id, channel){
    return this.http.get(`${this.apiUrl}/api/${channel}/signed-documents/${id}`);
  }
}
